import { DataSource, HorizontalSpacer, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCarrierSalesProfile extends Layout {
    horizontalspacer1: HorizontalSpacer;
    sourceCarrierSalesProfile: DataSource;
    textboxActDays: Textbox;
    textboxActType: Textbox;
    textboxCarrierId: Textbox;
    textboxCarrierRepId: Textbox;
    textboxDescr: Textbox;
    textboxId: Textbox;
    textboxSalesManagerId: Textbox;
    textboxSalespersonId: Textbox;
    textboxStatus: Textbox;
}
